import flagEnvDisplay from 'constants/flagEnvDisplay'

export const buttonsType = [
  'messages', 'people', 'chatmail', 'campaigns',
  ...flagEnvDisplay.displayGlobalSearchSmartchat ? ['smartchat'] : []
]
